import React, { useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { Container } from '@mui/system';
import { Grid } from '@mui/material';
import sidebar from "../../css/seller/Sidebar.module.css"
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';
import Badge from '@mui/material/Badge';


const drawerWidth = 320;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
    height: '90px',
}));

export default function PersistentDrawerLeft({ components, titleAppBar, userData }) {
    const [cookies, setCookie] = useCookies(['accessToken']);
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [user, setUser] = React.useState({});
    const [notif, setNotif] = React.useState([]);
    const [show, setShow] = React.useState(false)
    let color
    const navigate = useNavigate();
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    const logoItems = [
        <DashboardCustomizeRoundedIcon className={sidebar.sizeIcons} />, <StorefrontIcon className={sidebar.sizeIcons} />, <Inventory2OutlinedIcon className={sidebar.sizeIcons} />,
        <BorderColorOutlinedIcon className={sidebar.sizeIcons} />, <LogoutRoundedIcon className={sidebar.sizeIcons} />]
    let numLogo = 0

    React.useEffect(() => {
        const validateAccessToken = async () => {
            try {
                const url = 'https://w-shop-backend.vercel.app/api/auth/whoami';
                const rawResponse = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': 'Bearer ' + cookies.accessToken,
                    },
                })
                const response = await rawResponse.json();
                if (response.status !== 'success') {
                    throw new Error();
                }
                    setUser(response.data);
                    const urlNotif = 'https://w-shop-backend.vercel.app/api/notifications';
                    const rawResponseNotif = await fetch(urlNotif, {
                        method: 'GET',
                        headers: {
                            'Content-type': 'application/json',
                            'Authorization': 'Bearer ' + cookies.accessToken,
                        },
                    })
                    const responseNotif = await rawResponseNotif.json();
                    setNotif(responseNotif.data)
            } catch (error) {
                setCookie('accessToken', '', { path: '/' });
                navigate('/');
            }
        }
        if (cookies.accessToken === '') {
            navigate('/');
        } else {
            validateAccessToken();
        }
    }, [cookies.accessToken, setCookie, navigate])

    useEffect(() => {
        userData(user)
    }, [user, userData]);

    const isRead = async (idNotif) => {
        try {
            console.log(idNotif);
            // setIsLoading(true);
            const url = `https://w-shop-backend.vercel.app/api/notifications/${idNotif}/read`;
            const rawResponse = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': 'Bearer ' + cookies.accessToken,
                },
                // body: JSON.stringify(idNotif)
            });
            const response = await rawResponse.json(); console.log(response);
            if (response.status !== 'success') {
                throw new Error(response.message);
            } else {
                navigate(0)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const notifRead = []
    for (let i = 0; i < notif.length; i++) {
        if (notif[i].isRead === false) {
            notifRead.push(notif[i])
        }
    }

    return (
        <Box sx={{ display: 'flex', boxSizing: 'none', marginTop: '-25px' }}>
            <CssBaseline />
            <AppBar position="fixed" open={open} sx={{ background: 'white', color: "rgba(0, 102, 255, 0.45)", fontFamily: "alice", fontSize: "38px", height: 95, paddingTop: "15px" }}>
                <Container maxWidth='100%'>
                    <Grid container spacing={2} justifyContent='space-between'>
                        <Grid item>
                            <Toolbar>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    sx={{ mr: 2, ...(open && { display: 'none' }) }}
                                >
                                    <MenuIcon sx={{ color: "dodgerblue" }} />
                                </IconButton>
                                <h1 className=' d-none d-md-block'>{titleAppBar}</h1>
                            </Toolbar>
                        </Grid>
                        <Grid item >
                            <Toolbar>
                                <Badge badgeContent={notifRead.length} color="error" className='  me-md-5' sx={{ ...(open && { display: 'none' }) }} data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                    <img alt='' src='img/notificationBlue.png' width={25} height={25} />
                                </Badge>
                                <ul className="dropdown-menu p-0 d-borderbox " style={{width:'220px', height: "200px", overflow: 'hidden', overflowY: 'scroll' }} >
                                    {(show === false ? (
                                        <div className='user-select-none text-center py-2' onClick={() => { setShow(true) }}>Tampilkan semua</div>
                                    ) : (
                                        <div className='user-select-none text-center py-2' onClick={() => { setShow(false) }}>Sembunyikan</div>))}
                                    {
                                        (show === false) ? (
                                            notif.slice(0, 5).map((not, index) => {
                                                not.isRead === false ? (color = 'rgba(0, 102, 255, 0.15)') : (color='white')
                                                return (
                                                    <li key={index} className='px-2 pb-1 border-top' style={{ fontSize: "12px", backgroundColor: color }}>
                                                        {not.message}
                                                        <div className='text-primary text-end user-select-none' onClick={() => { isRead(not.id) }}>sudah dibaca</div>
                                                    </li>)
                                            })
                                        ) : (
                                            notif.map((not, index) => {
                                                not.isRead === false ? (color = 'rgba(0, 102, 255, 0.15)') : (color='white')
                                                return (<li key={index} className='px-2 pt-1' style={{ fontSize: "12px", backgroundColor: color }}>
                                                    {not.message}
                                                    <div className='text-primary text-end user-select-none' onClick={() => { isRead(not.id) }}>sudah dibaca</div>
                                                </li>)
                                            }))
                                    }
                                </ul>
                                <div className=' d-none d-lg-flex'>
                                    <img src={user.imgUrl} width={35} height={35} alt="" style={{ borderRadius: "50px" }} />
                                    <Typography
                                        sx={{
                                            fontFamily: 'Montserrat',
                                            fontStyle: 'normal',
                                            fontWeight: '500',
                                            fontSize: '20px',
                                            lineHeight: '24px',
                                            color: '#484848',
                                            marginLeft: '10px'
                                        }}
                                    >{user.owner}</Typography>
                                </div>
                            </Toolbar>
                        </Grid>
                    </Grid>
                </Container>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: 'rgba(0, 102, 255, 0.45)',
                        paddingLeft: '15px',
                        paddingRight: '15px'
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader sx={{ paddingRight: '0px', maxHeight: '14px', marginTop: '15px' }}>
                    <img alt='' src='/img/logo.png' className={sidebar.logo} />
                    <h1 className={sidebar.titleLogo}>W-Shop</h1>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <CloseIcon sx={{ color: "white" }} /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <hr sx={{ margin: '0px' }}></hr>
                <Divider sx={{ backgroundColor: "white" }} />
                <List sx={{ marginTop: '1', }}>
                    {
                        [{ "name": 'Dashboard', 'link': '/sellerDashboard' }, { "name": 'Toko', 'link': '/sellerToko' }, { "name": 'Produk', 'link': '/sellerProduct' }, { "name": 'Pesanan', 'link': '/sellerPesanan' }, { "name": 'Logout', 'link': '/logout' }].map((text, index) => (
                            <ListItem key={text.name} disablePadding >
                                <a data-testid={`sidebar-${text.name}`} href={text.link} style={{ textDecoration: 'none' }}>
                                    <ListItemButton sx={{ height: '90px', width: '300px' }}>
                                        <ListItemIcon sx={{ color: 'white' }}>
                                            { index === numLogo ? logoItems[numLogo++] : <StorefrontIcon sx={{ fontSize: '45px' }} />}
                                        </ListItemIcon>
                                        <ListItemText>
                                            <p style={{
                                                fontFamily: 'Montserrat',
                                                fontStyle: 'normal',
                                                fontWeight: '700',
                                                fontSize: '24px',
                                                lineHeight: '37px',
                                                color: '#FFFFFF',
                                                paddingTop: "15px"
                                            }}>{text.name}</p>
                                        </ListItemText>
                                    </ListItemButton>
                                </a>
                            </ListItem>
                        ))}
                </List>
                <Divider />
            </Drawer>
            <Main open={open} sx={{ backgroundColor: '#F1F1F1' }}>
                <DrawerHeader />
                {components}
            </Main>
        </Box>
    );
}
